import { CmsObjectWithDefault } from '@components/Cms/types';

export type DeleteAccountResultCmsKey =
    | 'DeleteAccountResultSuccess'
    | 'DeleteAccountResultError'
    | 'DeleteAccountResultUpcomingBooking'
    | 'DeleteAccountResultNeedCegHelp'
    | 'DeleteAccountResultCloseButton'
    | 'DeleteAccountResultPastBookingTooRecent'
    | 'BecauseHaveNotPassedYet'
    | 'DeleteAccountResultRequiredTime'
    | 'DeleteAccountResultRequiredTimeForChina'
    | 'WeAreSorryWeCannotDeleteYourAccountAutomatically'
    | 'YourProfileIsLinkedToAnNhaAccount'
    | 'YourProfileIsLinkedToAYcsAccount'
    | 'PleaseContactForAssistance'
    | 'AccountRetentionError'
    | 'AccountRetentionErrorCN'
    | 'UpcomingBookingError';

export const DeleteAccountResultCmsWithDefault: CmsObjectWithDefault<DeleteAccountResultCmsKey> = {
    DeleteAccountResultSuccess: {
        cmsId: 155199,
        defaultTranslation: 'Your account deletion has been completed.',
    },
    DeleteAccountResultError: {
        cmsId: 156085,
        defaultTranslation:
            "We're sorry, there was an error in deleting your account. Please try again later, or contact {0} for assistance.",
    },
    DeleteAccountResultUpcomingBooking: {
        cmsId: 155200,
        defaultTranslation: 'Your account cannot be deleted because you have an upcoming booking.',
    },
    DeleteAccountResultNeedCegHelp: {
        cmsId: 155201,
        defaultTranslation:
            "We're sorry, we are unable to delete your account automatically. Please contact {0} for support.",
    },
    DeleteAccountResultCloseButton: {
        cmsId: 155202,
        defaultTranslation: 'Close',
    },
    DeleteAccountResultPastBookingTooRecent: {
        cmsId: 156638,
        defaultTranslation: 'We have received your account deletion request.',
    },
    BecauseHaveNotPassedYet: {
        cmsId: 156639,
        defaultTranslation:
            'Because {0} have not passed yet, we cannot delete your account due to auditing purposes. We will register your account deletion petition and proceed with the deletion of your account once the required time has passed.',
    },
    DeleteAccountResultRequiredTime: {
        cmsId: 156640,
        defaultTranslation: '120 days',
    },
    DeleteAccountResultRequiredTimeForChina: {
        cmsId: 156641,
        defaultTranslation: '3 years',
    },
    WeAreSorryWeCannotDeleteYourAccountAutomatically: {
        cmsId: 156642,
        defaultTranslation:
            'We are sorry, we cannot delete your account automatically, due to one of the following reasons:',
    },
    YourProfileIsLinkedToAnNhaAccount: {
        cmsId: 156643,
        defaultTranslation: 'your profile is linked to an NHA account',
    },
    YourProfileIsLinkedToAYcsAccount: {
        cmsId: 156644,
        defaultTranslation: 'your profile is linked to a YCS account',
    },
    PleaseContactForAssistance: {
        cmsId: 156646,
        defaultTranslation: 'Please contact {0} for assistance.',
    },
    AccountRetentionError: {
        cmsId: 264399,
        defaultTranslation:
            "Your personal information will be removed from our systems and records or depersonalized so that you can no longer be identified from it, subject to limited circumstances where we are obligated to retain your account information as described in our <a href='https://www.agoda.com/info/privacy.html'>Privacy Policy</a>",
    },
    AccountRetentionErrorCN: {
        cmsId: 264401,
        defaultTranslation:
            "We received your request to delete your personal information but are unable to assist you at this moment.\nIn accordance with applicable laws and regulations of the People's Republic of China, a platform operator is required to retain all the historical transaction data for at least 3 years following the completion of the transaction.   As such, we will hold your account information and the historical booking information under your account until 3 years after the date of your last departed booking. If you require further assistance, please do not hesitate to contact our customer support team.",
    },
    UpcomingBookingError: {
        cmsId: 264400,
        defaultTranslation:
            'You still have an on-going/future booking with us, and your personal information is required to process and provide support.  We will delete your account automatically once the booking and required retention has concluded.',
    },
};
